// extracted by mini-css-extract-plugin
export var bounce = "LinkWebsite-module--bounce--7f7f1";
export var dotMoveLeft = "LinkWebsite-module--dot-move-left--0db30";
export var dotMoveRight = "LinkWebsite-module--dot-move-right--2de1b";
export var gradient = "LinkWebsite-module--gradient--6f8aa";
export var link = "LinkWebsite-module--link--5cccb";
export var separatorWidth = "LinkWebsite-module--separator-width--bd3b8";